import { AfterViewInit, Component, ElementRef, HostListener, Injector, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { BaseComponent } from 'src/app/common/base/base.component';
import { ResourcesService } from 'src/app/components/catalogs/beamline-catalog/resource/resources.service';
import { ResourceBeamlineStaffCatalog } from './beamline-staff';
import { BeamlineStaffSidePanelComponent } from './beamline-staff-side-panel/beamline-staff-side-panel.component';
import { BeamlineStaffMainPanelComponent } from './beamline-staff-main-panel/beamline-staff-main-panel.component';
import { StatusResource } from 'src/app/common/enumerations/enumerations';

@Component({
  selector: 'app-beamline-staff',
  templateUrl: './beamline-staff.component.html',
  styleUrls: ['./beamline-staff.component.scss']
})
export class BeamlineStaffComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit
{

  @ViewChild("sidenav") sidenav!: MatSidenav;
  @ViewChild("headerTop") headerTop!: ElementRef;

  @ViewChild(BeamlineStaffMainPanelComponent) main?: BeamlineStaffMainPanelComponent;

  disabled: boolean = false;

  loading = false;

  resourceRequired: boolean = false;

  filterCtrl = new FormControl();

  errorMessages: string[] = [];
  headerOnTop: boolean = false;

  valueFilter!: string;
  createdOn!: string;

  ///////
  tmpFilter!: string;
  condition!: string;
  filteredFilter: any[] = [];
  currentFilter: any;
  filter: any;

  element!: any;

  beamlines?: any[];
  beamlinesFiltered?: any[];

  loadingMessage!: string;

  showAmendmentToggle: boolean = false;
  private resizeTimer: any;
  //////

  constructor(
    protected override injector: Injector,
    private service: ResourcesService
  )
  {
    super(injector);
  }

  ngAfterViewInit(): void
  {
    this.setHeights();
  }

  ngOnChanges(changes: SimpleChanges): void
  {
  }

  ngOnInit()
  {
    this.moduleTitle = 'US 02-05 Appendix 1: ALS Responsible Beamline Scientists / Alternate Responsible Scientists';
    this.getBeamlinesStaff();
  }


  /**
   * Retrieves and processes staff beamlines data.
   * Filters active/commissioning beamlines and sorts them alphabetically.
   */
  getBeamlinesStaff()
  {
    // Set loading state
    this.setLoading(true, this.loadingOrigin.Main);
    
    // Fetch staff data from service
    this.service.getAllResourceStaff().toPromise().then(
      (data) =>
      {
        // Filter and sort beamlines by status and name
        this.beamlines = data;
        this.beamlinesFiltered = this.beamlines?.filter(b => b.status == StatusResource.Active || b.status == StatusResource.Commissioning).sort((a, b) => this.utils.sortArrayAlphabeticallyWithComplexNumbers(a.beamlineName, b.beamlineName));
        // this.beamlines?.sort((a, b) => this.utils.sortArrayAlphabeticallyWithComplexNumbers(a.beamlineName, b.beamlineName));
        
        // Clear loading state
        this.setLoading(false, this.loadingOrigin.Main);
      },
      (error) =>
      {
        // Handle service errors
        console.error(error);
      }
    );
  }

  /**
   * Scrolls to the specified beamline in the main panel.
   * @param b The beamline catalog resource to scroll to.
   */
  scrollTo(b: ResourceBeamlineStaffCatalog)
  {
    this.main?.scrollToBeamline(b);
  }

  clear()
  {
    this.errorMessages = [];
  }

  create() { }
  release() { }

  async setEditing(value: boolean)
  {
  }

  @HostListener("window:resize")
  onResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.innerWidth = window.innerWidth;
      if (this.innerWidth < 768) {
        this.isExpanded = false;
      }
    }, 200);
  }

  @HostListener("window:scroll")
  isHeaderOnTop()
  {
    let elemRec;
    if (this.headerTop?.nativeElement !== undefined)
    {
      elemRec = this.headerTop.nativeElement.getBoundingClientRect();
      const docViewTop = window.screenTop;
      const elemTop = elemRec.top;
      if (elemTop <= docViewTop)
      {
        this.headerOnTop = true;
      } else
      {
        this.headerOnTop = false;
      }
      // this.tableWidth = this.scheduleTable.nativeElement.offsetWidth + 'px';
    } else
    {
      this.headerOnTop = false;
    }
  }

  //////
  changedFilter() { }
  clearFilter() { }
  selectedFilter() { }
  createDisabled() { }
  editDisabled() { }
  action() { }

  applyFilter(e: any)
  {
    if (!e)
      this.valueFilter = '';
    this.filter = e;
  }

  checkPrivileges() { }

  duplicate() { }

  requestAmendment() { }

  setLoading(e: any, origin: any)
  {
    if (!e)
    {
      setTimeout(() =>
      {
        this.showLoading(e, origin);
      }, 2000);
    }
    else { this.showLoading(e, origin); }
  }

  showLoading(e: boolean, origin: any)
  {
    setTimeout(() =>
    {
      switch (origin)
      {
        case LoadingOrigin.Side:
          this.loadingSide = e as boolean;
          break;
        case LoadingOrigin.Buttons:
          this.loadingButtons = e as boolean;
          break;
        case LoadingOrigin.Main:
          this.loadingMain = e as boolean;
          break;
      }
      // console.log('m: ' + this.loadingMain + '   b: ' + this.loadingButtons + '   s: ' + this.loadingSide);
      this.loading = this.loadingMain || this.loadingButtons || this.loadingSide;
    }, 100);
  }
  loadingSide = false;
  loadingButtons = false;
  loadingMain = false;
  loadingOrigin = LoadingOrigin;
}

enum LoadingOrigin
{
  Side = 1, Buttons = 2, Main = 3
}
